import { render } from "./opportunity.vue?vue&type=template&id=cf63690e&scoped=true"
import script from "./opportunity.vue?vue&type=script&lang=js"
export * from "./opportunity.vue?vue&type=script&lang=js"

import "./opportunity.vue?vue&type=style&index=0&id=cf63690e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-cf63690e"

export default script